import React from "react";
import "./Blog.css";

function Blog() {
  return (
    <div className="HomePage">
      <header className="HomePage-header">
        <header class="UnderConstruction-header">
          <h1>Coming Soon</h1>
        </header>
        <section class="UnderConstruction-content">
          <p>This page is currently under construction. Stay tuned!</p>
        </section>
      </header>
    </div>
  );
}

export default Blog;
